<c-row>
  <c-col>
    <c-card>
      <c-card-body>
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h5 class="mb-0">Monthly Retention Data</h5>
          <div class="d-flex align-items-center gap-2">
            <label for="yearInput" class="form-label mb-0">Year:</label>
            <input id="yearInput" type="number" min="2025" [max]="currentYear" class="form-control d-inline-block" style="width: 100px;" [value]="year" (change)="onYearChange($event)">
          </div>
        </div>
        <!-- Yearly Retention Chart -->
        <div class="chart-card mb-4">
          <div class="chart-controls d-flex align-items-center flex-wrap gap-3 mb-3">
            <div class="btn-group" role="group">
              <button
                class="btn btn-sm"
                [class.btn-primary]="chartType === 'line'"
                [class.btn-outline-primary]="chartType !== 'line'"
                (click)="setChartType('line')">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16" class="me-1"><path d="M0 0h1v15h15v1H0V0zm14.828 2.172a.5.5 0 0 0-.707 0L8 8.293 5.854 6.146a.5.5 0 0 0-.707 0l-5 5a.5.5 0 0 0 .707.708L5.5 7.207l2.146 2.147a.5.5 0 0 0 .707 0l6.475-6.475a.5.5 0 0 0 0-.707z"/></svg>
                Line
              </button>
              <button
                class="btn btn-sm"
                [class.btn-primary]="chartType === 'bar'"
                [class.btn-outline-primary]="chartType !== 'bar'"
                (click)="setChartType('bar')">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16" class="me-1"><path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H2z"/><path d="M4 11v-4h1v4H4zm2-6v6h1V5H6zm2 3v3h1V8H8zm2-2v5h1V6h-1z"/></svg>
                Bar
              </button>
            </div>
            <div class="chart-legend d-flex align-items-center gap-3 ms-2">
              <ng-container *ngFor="let cfg of dsConfigs; let i = index">
                <button
                  class="legend-pill"
                  [class.legend-pill--hidden]="!datasetVisibility[i]"
                  [style.--pill-color]="cfg.borderColor"
                  (click)="toggleDataset(i)">
                  <span class="legend-dot" [style.background]="cfg.borderColor"></span>
                  {{ cfg.label }}
                </button>
              </ng-container>
            </div>
          </div>
          <ng-container *ngIf="showChart">
            <c-chart
              [type]="chartType"
              [data]="chartData"
              [options]="chartOptions"
              (chartRef)="onChartRef($event)"
              class="retention-chart"
            ></c-chart>
          </ng-container>
        </div>

        <div class="grid-container">
          <ng-container *ngFor="let row of retentionRows">
            <c-row class="mb-3">
              <c-col>
                <c-card>
                  <c-card-header class="ret-month-header">{{ row.month }}</c-card-header>
                  <c-card-body>
                    <table class="table table-bordered table-sm mb-0 text-center align-middle">
                      <thead>
                        <tr class="ret-table-row">
                          <th rowspan="2" class="ret-table-cell">Employees Start</th>
                          <th rowspan="2" class="ret-table-cell">Employees End</th>
                          <th rowspan="2" class="ret-table-cell">New Hires</th>
                          <th rowspan="2" class="ret-table-cell">Retention Rate</th>
                          <th rowspan="2" class="ret-table-blank"></th>
                          <th rowspan="2" class="ret-table-cell">For Replacement</th>
                          <th colspan="2" class="ret-table-cell">Attrition</th>
                          <th class="ret-table-blank"></th>
                          <th rowspan="2" class="ret-table-cell">Resigned/Quit</th>
                          <th rowspan="2" class="ret-table-cell">Awol</th>
                          <th rowspan="2" class="ret-table-cell">Terminated/Fired</th>
                          <th rowspan="2" class="ret-table-cell">Endo</th>
                        </tr>
                        <tr class="ret-table-row">
                          <th class="ret-table-cell">Voluntary</th>
                          <th class="ret-table-cell">Involuntary</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr class="ret-table-row">
                          <td rowspan="2" class="ret-table-cell">{{ row.start_count }}</td>
                          <td rowspan="2" class="ret-table-cell">{{ row.end_count }}</td>
                          <td rowspan="2" class="ret-table-cell">{{ row.new_hires }}</td>
                          <td rowspan="2" class="ret-table-cell">{{ row.retention_rate && row.retention_rate !== '\u00A0' ? (row.retention_rate + ' %') : '\u00A0' }}</td>
                          <td rowspan="2" class="ret-table-blank"></td>
                          <td rowspan="2" class="ret-table-cell">{{ row.replacement_count }}</td>
                          <td class="ret-table-cell">{{ +row.resigned + +row.awol }}</td>
                          <td class="ret-table-cell">{{ +row.terminated + +row.endo }}</td>
                          <td rowspan="2" class="ret-table-blank"></td>
                          <td rowspan="2" class="ret-table-cell">{{ row.resigned }}</td>
                          <td rowspan="2" class="ret-table-cell">{{ row.awol }}</td>
                          <td rowspan="2" class="ret-table-cell">{{ row.terminated }}</td>
                          <td rowspan="2" class="ret-table-cell">{{ row.endo }}</td>
                        </tr>
                        <tr style="border: none;">
                          <td colspan="2" class="ret-table-cell">{{ +row.resigned + +row.awol + +row.terminated + +row.endo }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </c-card-body>
                </c-card>
              </c-col>
            </c-row>
          </ng-container>
        </div>
      </c-card-body>
    </c-card>
  </c-col>
</c-row>
